import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import Select from 'react-select'
import { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import axios from "axios";
import { api_url, AXIOS_HEADER } from "../../constants/data";

const NewTask = () => {
    const navigate = useNavigate(); // Initialize the navigate function
    const[selectedFile, setSelectedFile] = useState(null)
    const fileTypes = ["jpg", "png", "pdf", "xlxs", "doc"];
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const[showStartDate, setShowStartDate] = useState(false)
    const[showEndDate, setShowEndDate] = useState(false)
    const[departments, setDepartments] = useState([])
    const[selectedDepartments, setSelectedDepartments] = useState([])
    const[departmentUsers, setDeparmentUsers] = useState([])
    const[selectedDepartmentUsers, setSelectedDeparmentUsers] = useState([])
    const[selectedCCUsers, setSelectedCCUsers] = useState([])
    const[formData, setFormData] = useState({
        departments: [],
        users: [],
        cc_users: [],
        title: '',
        description: '',
        status: null,
        start_date: '',
        end_date: '',
        file: null
    })
    const[errors, setErrors] = useState([])

    useEffect(() => {
        axios.post(`${api_url}/departments`, {}, AXIOS_HEADER).then(res => {
            setDepartments(res.data)
        })
    }, [])

    useEffect(() => {
        if(selectedDepartments.length == 0) return
        axios.post(`${api_url}/departments-users`, {departments: selectedDepartments}, AXIOS_HEADER).then(res => {
            setDeparmentUsers(res.data)
        })
    }, [selectedDepartments])


    useEffect(() => {
        setShowStartDate(false)
        setShowEndDate(false)
    }, [startDate, endDate])
    
    const handleChange = (file) => {
        setSelectedFile(file);
    };

    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]

    const departmentsHandler = items => {
        const ids = []
        items.map(x => {
            ids.push(x.value)
        })

        setSelectedDepartments([...ids])
    }

    const departmentsUserHandler = items => {
        const ids = []
        items.map(x => {
            ids.push(x.value)
        })

        setSelectedDeparmentUsers([...ids])
    }

    const CCUserHandler = items => {
        const ids = []
        items.map(x => {
            ids.push(x.value)
        })

        setSelectedCCUsers([...ids])
    }

    const submit = () => {  
        setErrors([])
        const fd = {...formData}
        fd.departments = selectedDepartments
        fd.users = selectedDepartmentUsers
        fd.cc_users = selectedCCUsers   
        fd.start_date = moment(startDate).format('YYYY-MM-DD')
        fd.end_date = moment(endDate).format('YYYY-MM-DD')
        fd.file = selectedFile

        const errs = []
        if(fd.departments.length == 0) {
            errs.push('განყოფილება არ არის არჩეული')
        }

        if(fd.users.length == 0) {
            errs.push('შემსრულელი არ არის არჩეული')
        }

        if(fd.start_date > fd.end_date){
            errs.push("დასრულების თარიღი არ უნდა იყოს დაწყების თარიღზე ნაკლები")
        }

        if(fd.title.length == 0) {
            errs.push('დავალების სათაური ცარიელია')
        }

        if(fd.description.length == 0) {
            errs.push('დავალების შინაარსი ცარიელია')
        }

        if(fd.status == null) {
            errs.push('სტატუსი არ არის არჩეული')
        }

        if(errs.length > 0) {
            setErrors(errs)
        } else {
            const nfd = new FormData()

            Object.keys(fd).map(x => {
                nfd.append(x, fd[x])
            })

            axios.post(`${api_url}/create-task`, nfd, AXIOS_HEADER).then(res => {
                if(res.data.status == 'success') {
                    navigate('/')
                }
            }).catch(e => console.log(e))
        }



    }


    return (
        <DashboardLayout>
            <div className="header_wrapper">
                <div className="header_icon">
                    <img src="/icons/flag.png" alt="" />
                </div>
                <div className="header_title">
                    <p>ახალი დავალება</p>
                </div>
            </div>

            <div className="task_form">
                <div className="form_control">
                    <label htmlFor="">განყოფილება</label>
                    <Select options={departments.map(x => {
                        return { value: x.id, label: x.name }
                    })} onChange={departmentsHandler} isMulti  />
                </div>
                <div className="form_control">
                    <label htmlFor="">შემსრულებელი</label>
                    <Select options={departmentUsers.map(x => {
                        return { value: x.id, label: x.name + ' ' + x.lastname }
                    })} isMulti onChange={departmentsUserHandler} />
                </div>
                <div className="form_control w-100">
                    <label htmlFor="">Cc</label>
                    <Select options={departmentUsers.map(x => {
                        return { value: x.id, label: x.name + ' ' + x.lastname }
                    })} isMulti onChange={CCUserHandler} />
                </div>
                <div className="form_control">
                    <label htmlFor="">დასაწყისი</label>
                    <input type="text" placeholder="ჩაწერეთ..." onClick={() => setShowStartDate(true)} readOnly value={moment(startDate).format('DD-MM-YYYY')} />
                    {showStartDate && (
                        <Calendar onChange={setStartDate} value={startDate} />
                    )}
                </div>
                <div className="form_control">
                    <label htmlFor="">დასასრული</label>
                    <input type="text" placeholder="ჩაწერეთ..."  onClick={() => setShowEndDate(true)} readOnly value={moment(endDate).format('DD-MM-YYYY')} />
                    { showEndDate && (
                        <Calendar onChange={setEndDate} value={endDate} />
                    ) }
                </div>
                <div className="form_control w-100">
                    <label htmlFor="">დავალება</label>
                    <input type="text" placeholder="ჩაწერეთ..." onChange={(e) => setFormData({...formData, title: e.target.value })} />
                </div>
                <div className="form_control w-100">
                    <label htmlFor="">შინაარსი</label>
                    <textarea placeholder="ჩაწერეთ..." rows={6} onChange={(e) => setFormData({...formData, description: e.target.value })} ></textarea>
                </div>
                <div className="form_control w-100">
                    <label htmlFor="">სტატუსი</label>
                    <Select options={[
                        { value: 1, label: 'სტანდარტული' },
                        { value: 2, label: 'პრიორიტეტული' },
                    ]} onChange={(e) => setFormData({...formData, status: e.value })}  />
                </div>

                { errors.length > 0 && (
                    <div className="form_errors">
                        { errors.map(x => <p>{x}</p>) }
                    </div>
                )}

                <div className="form_buttons">
                    <div className="form_action_btn">
                        <button onClick={() => navigate('/')}>უკან</button>
                    </div>
                    <div className="form_action_btn">
                        <button onClick={submit}>დავალების ბაზაში დამატება</button>
                    </div>
                </div>

                <div className="drop_file w-100">
                    <FileUploader handleChange={handleChange} name="file" types={fileTypes}  >
                        { selectedFile ? (
                            <>
                                <p>Selected file: { selectedFile.name }</p>
                                <p onClick={() => setSelectedFile(null)} >Remove</p>
                            </>
                        ) : (
                            <>
                                <img src="/icons/plus-circle.png" alt="" />
                                <p>Drag & Drop files or choose files</p>
                                <span> <img src="/icons/information-circle.png" alt="" /> Max file size: 10 MB</span>
                            </>
                        ) }
                        
                    </FileUploader>
                </div>
            </div>

        </DashboardLayout>
    )
}
  
export default NewTask